import { viewManager } from '../common/data-view.js';
viewManager.register('table', {
    defaultName: 'Table View',
    init(model, id, name) {
        return {
            id,
            name,
            mode: 'table',
            columns: [],
            filter: {
                type: 'group',
                op: 'and',
                conditions: [],
            },
            header: {
                titleColumn: model.columns.find(v => v.type === 'title')?.id,
                iconColumn: 'type',
            },
        };
    },
});
//# sourceMappingURL=define.js.map